/**
 * SPEC-08 §2.4 — density toggle button.
 *
 * Single-tap switch between `comfortable` and `compact`. Mounted in
 * `TopNav` next to the language/theme toggles. Persists via `useDensity`
 * → `localStorage`.
 */

import { Rows3, Rows4 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

import { useDensity } from "./useDensity";

export function DensityToggle({ className }: { className?: string }) {
  const { t } = useTranslation();
  const [density, setDensity] = useDensity();
  const next = density === "comfortable" ? "compact" : "comfortable";
  const label = t(`ui.density.toggle.${next}`);
  const Icon = density === "comfortable" ? Rows4 : Rows3;
  return (
    <Button
      variant="ghost"
      size="icon"
      type="button"
      aria-label={label}
      title={label}
      onClick={() => setDensity(next)}
      data-testid="density-toggle"
      data-density={density}
      className={className}
    >
      <Icon size={20} aria-hidden="true" />
    </Button>
  );
}
